'use client';
import React, { useState } from 'react';
import { toast } from 'sonner';
import Icon from '@/components/ui/AppIcon';

const amounts = [50, 100, 150, 200];

interface ReloadCardProps {
  balance: number;
  onReload: (amount: number) => void;
}

export default function ReloadCard({ balance, onReload }: ReloadCardProps) {
  const [selected, setSelected] = useState<number>(100);
  const [loading, setLoading] = useState(false);

  function handleReload() {
    setLoading(true);
    // Backend integration: POST /api/payment/reload with amount and cardId
    setTimeout(() => {
      onReload(selected);
      setLoading(false);
      toast.success(`Kart başarıyla yüklendi!`, {
        description: `₺${selected} bakiyenize eklendi. Yeni bakiye: ₺${(balance + selected).toFixed(2)}`,
      });
    }, 1500);
  }

  return (
    <div>
      <div className="bg-card rounded-2xl p-5 card-shadow mb-4">
        <h3 className="text-foreground font-bold text-base mb-1">Kart Yükle</h3>
        <p className="text-muted-foreground text-sm mb-4">Mevcut Bakiye: <span className="text-foreground font-bold">₺{balance.toFixed(2).replace('.', ',')}</span></p>

        {/* Amount grid */}
        <div className="grid grid-cols-2 gap-3 mb-4">
          {amounts.map((amount) => (
            <button
              key={`amount-${amount}`}
              onClick={() => setSelected(amount)}
              className={`py-4 rounded-2xl border-2 text-center transition-all ${
                selected === amount
                  ? 'border-primary bg-accent text-primary' :'border-border bg-card text-foreground hover:border-primary/30'
              }`}
            >
              <p className="font-bold text-xl">₺{amount}</p>
              {amount === 100 && (
                <p className="text-xs text-primary font-semibold mt-0.5">+5★ Bonus</p>
              )}
              {amount === 200 && (
                <p className="text-xs text-gold font-semibold mt-0.5">+20★ Bonus</p>
              )}
            </button>
          ))}
        </div>

        {/* Stars bonus note */}
        {selected >= 30 && (
          <div className="bg-gold-light rounded-xl p-3 flex items-center gap-2 mb-4">
            <Icon name="StarIcon" size={16} variant="solid" className="text-gold" />
            <span className="text-foreground text-sm">
              ₺{selected} yükleme için{' '}
              <span className="font-bold text-gold">+{Math.floor(selected / 10)} Bonus Yıldız</span> kazanırsınız
            </span>
          </div>
        )}

        <button
          onClick={handleReload}
          disabled={loading}
          className="w-full bg-primary text-white font-bold py-4 rounded-2xl flex items-center justify-center gap-2 hover:bg-primary/90 transition-colors active:scale-[0.98] disabled:opacity-70"
        >
          {loading ? (
            <>
              <svg className="animate-spin w-5 h-5" viewBox="0 0 24 24" fill="none">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
              </svg>
              <span>Yükleniyor...</span>
            </>
          ) : (
            <span>₺{selected} Yükle</span>
          )}
        </button>
      </div>

      {/* Payment methods */}
      <div className="bg-card rounded-2xl p-4 card-shadow">
        <p className="text-foreground font-semibold text-sm mb-3">Ödeme Yöntemi</p>
        <div className="flex items-center gap-3 p-3 border border-primary rounded-xl">
          <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
            <span className="text-white text-xs font-bold">VISA</span>
          </div>
          <div>
            <p className="text-foreground font-semibold text-sm">Visa **** 4521</p>
            <p className="text-muted-foreground text-xs">Son Kullanma: 08/28</p>
          </div>
          <Icon name="CheckCircleIcon" size={18} variant="solid" className="text-primary ml-auto" />
        </div>
      </div>
    </div>
  );
}